import React, { useId, useState, ChangeEventHandler } from 'react';
import Image from 'next/legacy/image';

import {
  TextInputWrapper,
  InputLabel,
  SelectInput,
  ErrorMessage,
  IconWrapper
} from './style';

import { BaseInputProps, TextInputWidth } from '../shared';

import icon from '@/images/error_icon.svg';

export interface SelectOptions {
  key: string | number;
  value: string;
}

interface TextInputProps extends BaseInputProps {
  options: SelectOptions[];
  handleOnChange: ChangeEventHandler<HTMLSelectElement>;
  variant?: 'default' | 'filterbar' | 'gl4c' | 'selectstate';
  className?: string;
  wrapperClassName?: string;
  labelClassName?: string;
}

export function Select({
  options,
  value,
  type,
  label,
  error,
  required,
  handleOnChange,
  disabled = false,
  width = TextInputWidth.FULL,
  variant = 'default',
  className = '',
  wrapperClassName = '',
  labelClassName = ''
}: TextInputProps) {
  const [isFocused, setIsFocused] = useState<boolean>(false);
  const inputId = useId();

  return (
    <>
      <TextInputWrapper
        width={width}
        error={!!error}
        variant={variant}
        className={wrapperClassName}
      >
        <InputLabel
          data-testid={`${label}-testid`}
          variant={variant}
          htmlFor={inputId}
          floatLabel={!!value || isFocused}
          className={labelClassName}
        >
          {label}
          {required ? '*' : ''}
        </InputLabel>

        <SelectInput
          value={value}
          variant={variant}
          data-testid={`select-${type}-${label}`}
          onChange={handleOnChange}
          required={required}
          className={className}
          disabled={disabled}
          onFocus={() => {
            setIsFocused(true);
          }}
          onBlur={() => {
            setIsFocused(false);
          }}
        >
          {options.map((option) => (
            <option key={option.key}>{option.value}</option>
          ))}
        </SelectInput>
      </TextInputWrapper>
      <ErrorMessage
        data-testid={`input-${type}-${label}-error`}
        visible={!!error}
        variant={variant}
      >
        <IconWrapper>
          <Image src={icon} alt="Form input error" />
        </IconWrapper>
        {error || ''}
      </ErrorMessage>
    </>
  );
}
